import * as React from 'react';
import './DragHandleCell.scss';
import { GridCellProps } from '@progress/kendo-react-grid';

export const DragHandleCell = (props: GridCellProps) => {
    return (
        <td {...props as unknown as React.HTMLAttributes<HTMLTableCellElement>}>
            <div className="dragCellStyles">
                <span className="k-icon k-i-reorder" style={{ cursor: 'move' }} data-drag-handle={true} />
            </div>
        </td>
    );
};
